// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__g4Lhp","inputWrap":"Table_inputWrap__p4kEq","col":"Table_col__1ycwR","bmiTooltip":"Table_bmiTooltip__2YzeS"};